import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarDots = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2.2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 3,
		y: 5,
		width: 18,
		height: 16,
		rx: 2
	}), /* @__PURE__ */ _jsx("path", { d: "M3 10h18M8 3v4M16 3v4M8 14h2M14 14h2" })]
});
export default SvgCalendarDots;
